import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import vco from "v-click-outside"

import App from './App.vue'
import router from './router'
import VueFeather from 'vue-feather'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueAlertify from "vue-alertify"
import VueMask from 'v-mask'
import VueQuillEditor from 'vue-quill-editor'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueVectorMap from 'vuevectormap'
import i18n from './i18n'
import store from '@/state/store'
import { authentication } from '@/services/auth';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';
import Amplify from '@aws-amplify/core';

let awsConfig = {
    "aws_project_region": process.env.VUE_APP_AWS_REGION,
    "aws_cloud_logic_custom": [
        {
            "name": process.env.VUE_APP_AWS_API_NAME,
            "endpoint": process.env.VUE_APP_AWS_API_URL,
            "region": process.env.VUE_APP_AWS_REGION
        }
    ],
    "aws_cognito_identity_pool_id": process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
    "aws_cognito_region": process.env.VUE_APP_AWS_REGION,
    "aws_user_pools_id": process.env.VUE_APP_AWS_USERPOOL_ID,
    "aws_user_pools_web_client_id": process.env.VUE_APP_AWS_USERPOOL_CLIENT_ID,
    "aws_user_files_s3_bucket": process.env.VUE_APP_AWS_S3_BUCKET,
    "aws_user_files_s3_bucket_region": process.env.VUE_APP_AWS_REGION
};

Amplify.configure(awsConfig);

import { VueReCaptcha } from 'vue-recaptcha-v3';
import AsyncComputed from 'vue-async-computed';
import ChatSupport from "@/components/chat-support.vue";

applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/amplify-\w*/];

import '@/assets/scss/app.scss';

import "@/plugins/vee-validate";
import "@/plugins/outside";
import "@/plugins/sweetalert";
import "@/plugins/fb";
import "@/plugins/toast";
import "@/plugins/clipboard";
import "@/plugins/google-maps";

// pls work  - added toasted bread
import ToastPlugin from '@/plugins/toast'; 

// Added toasted bread plugin use it globally
Vue.use(ToastPlugin);

Vue.use(VueReCaptcha, { 
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true
  }
});
Vue.use(AsyncComputed);
Vue.use(VueFeather);
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.component('apexchart', VueApexCharts)
Vue.component('chat-support', ChatSupport)
Vue.use(Vuelidate)
Vue.use(VueEasyLightbox)
Vue.use(VueAlertify)
Vue.use(VueMask)
Vue.use(VueQuillEditor)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(VueVectorMap)

Vue.filter('toCurrency', function (value, currency = '') {
  if (typeof value !== "number") {
      return value;
  }
  if(currency != ''){
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency//'PHP'
    });
    return formatter.format(value);
  }else{

    return Number(value).toLocaleString('en', { 
      minimumFractionDigits: 2,
      maximumFractionDigits: 2 
    });
    // return value.toFixed(2);
  }
});

Vue.filter('formatDate', function(value) {
  if (value) {
    var dateOptions = {  
      day: "numeric", // numeric, 2-digit
      year: "numeric", // numeric, 2-digit
      month: "long", // nume };
    }
    
    let date = new Date(value);
    return date.toLocaleDateString('en', dateOptions);
  }
});

Vue.filter('truncator', function(text = '', length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});

authentication();

try {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')
} catch (error) {
  console.log(error);  
}